<canvas #canvas
        (click)="onCanvasClick($event)"
        [style.cursor]="currentCursor"></canvas>
